import { z } from 'zod';

import {
  ViolationTypeWritableShape,
  assertSuspensionDaysMatchAction,
} from '../violation-type-create/violation-type-create';

/**
 * Editing a violation type (`violations.manage`).
 *
 * **The `key` is absent, and its absence is the rule.** The key is the label
 * handed to the classifier *and* the join every `violations` row was
 * judged under; renaming it would silently re-point history at a category that
 * did not exist when those messages were sent, and would change what the model
 * is asked without anybody editing the guidance. A type that is wrong is
 * deactivated (`isActive: false`) and a new one created — the same discipline
 * the permission catalogue keeps for orphaned keys (N8).
 *
 * Everything else is editable, which is the whole point: "changing a type's
 * action in admin changes behaviour without deploy" is this schema plus
 * `EnforcementService` reading the row at the moment it acts.
 *
 * `.partial()` before the refinement, so a request that changes only the
 * severity is not obliged to restate the action — and
 * {@link assertSuspensionDaysMatchAction} stays inert when the action is not
 * named, because only the service knows the merged row.
 */
export const ViolationTypeUpdateSchema = z
  .object(ViolationTypeWritableShape)
  .partial()
  .strict()
  .superRefine(assertSuspensionDaysMatchAction);

export type ViolationTypeUpdateRequest = z.infer<typeof ViolationTypeUpdateSchema>;
